<template>
  <section id="business">
    <div class="row">
      <div class="col-12 col-md-6 funny-backgroudn" style="text-align: center;padding: 150px 0px;">
        <p style="font-size: 34px;">Geschäftkunden</p>

        <h6>Kleiner Glashalm.<br class="d-md-none"> Große Wirkung.</h6>
        <div style="font-size: 20px;">Gut für die Umwelt. Gut für die Kunden.</div>
      </div>

      <div class="col-12 col-md-6 text-left business-benefits">
        <div class="biz-group" style="font-size: 34px; margin-bottom: 5px;">Unsere Vorteile. <br class="d-md-none"> Ihr
          Profit.
        </div>
        <div style="width: 240px; margin: auto">
          <br>
          <table>
            <tr>
              <td>✔</td>
              <td>Attraktive Mengenabatte</td>
            </tr>
            <tr>
              <td>✔</td>
              <td>Big Bags</td>
            </tr>
            <tr>
              <td>✔</td>
              <td>Hohes Einsparpotenzial durch</td>
            </tr>
            <tr>
              <td></td>
              <td>Verzicht auf Einwegprodukte</td>
            </tr>
            <tr>
              <td>✔</td>
              <td>Schnelle Lieferung</td>
            </tr>
          </table>
        </div>
        <div class="biz-group" style="margin: 20px 0;">
          <a href="https://glastrinkhalm.shop/registerFC/index/sValidation/H"
             class="btn btn-primary btn-gastro">Gastro & Fachhandel</a>
          <a href="#contact" class="btn btn-primary">Großhandel</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Vue } from 'vue-property-decorator'

export default class Business extends Vue {

}
</script>

<style scoped>
  .biz-group {
    display: flex;
    justify-content: center;
  }

  .business-benefits {
    padding-left: 80px;
    padding-top: 30px;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  h6 {
    font-size: 30px;
  }

  .funny-backgroudn {
    background-color: var(--nav-hover-color);
    color: white;
  }

  .btn-gastro {
    margin-right: 30px;
  }

  section {
    padding-bottom: 0;
  }

  @media screen and (max-width: 1100px) {
    .btn-gastro {
      margin-right: 15px;
    }

    section {
      padding-top: 0;
    }

    .row {
      margin: unset;
    }

    .business-benefits {
      padding-left: 15px;
    }

    h6 {
      font-size: 25px;
    }
  }

  @media screen and (max-width: 1100px) {
    section {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
